let tiandtiu_tk = '16554181e1d8f9f3b82ce84fe953c164'
/**
 * 基础地图
 */
export default {
  EPSG3857: {
    /**
     * 谷歌地图
     */
    GoogleMap: { //http://www.google.cn/maps/vt?lyrs={v}@{s}&gl=cn&x={x}&y={y}&z={z}
      url: 'http://mt{s}.google.cn/vt/lyrs={v}&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}',
      options: {
        subdomains: '0123'
      },
      v: {
        Normal: 'm', //全地图
        Satellite_N: 's', //卫星图
        Satellite: 'y', //卫星图(含标注)
        Terrain: 't', //地形图
        Terrain_R: 'p', //地形图+
        Skeleton_D: 'r', //黑色轮廓图 dark
        Skeleton_H: 'h', //高亮轮廓图 light
        Hybrid: 'y' //混合卫星图/影像图?
      }
    },
    /**
     * 百度地图
     */
    BaiduMap: {
      url: "http://online{s}.map.bdimg.com/tile/?qt=tile&x={x}&y={y}&z={z}&styles={v}&v=020",
      options: {
        minZoom: 3,
        maxZoom: 19,
        subdomains: '0123456789',
        tms: true
      },
      v: {
        Normal: 'pl',
        A: 'sl',
        Satellite: {
          url: 'http://shangetu{s}.map.bdimg.com/it/u=x={x};y={y};z={z};v=009;type=sate&fm=46'
        },
      }
    },
    /**
     * 全国天地图 
     */
    Tianditu: {
      url: 'http://t{s}.tianditu.gov.cn/DataServer?T={v}&x={x}&y={y}&l={z}&tk=' + tiandtiu_tk,
      // url: 'http://t{s}.tianditu.com/DataServer?T={v}&x={x}&y={y}&l={z}',
      // url = 'http://t{s}.tianditu.com/cva_c/wmts/{z}/{y}/{x}' 错误的服务地址？
      // url = 'http://t{s}.tianditu.cn/vec_c/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=c&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=tiles',//4326
      options: {
        subdomains: '01234567',
      },
      v: {
        Normal: 'vec_w', //矢量地图
        Normal_A: 'cva_w', //矢量-标注图
        Terrain: 'ter_w', //地形图
        Terrain_A: 'cta_w', //地形-标注图
        Satellite: 'img_w', //卫星影像图
        Satellite_A: 'cia_w', //卫星-标注图
      }
    },
    /**
     * 高德地图
     */
    GaodeMap: {
      url: 'http://web{v}0{s}.is.autonavi.com/appmaptile?lang=zh_cn&style={style}&x={x}&y={y}&z={z}',
      options: {
        minZoom: 3,
        subdomains: '1234',
        attribution: '&copy; <a>GaoDeMap</a>'
      },
      v: {
        Normal: { // 交通图
          options: {
            v: 'rd',
            style: 8
          }
        },
        Vector: { // 矢量路网
          options: {
            v: 'rd',
            style: 7
          }
        },
        Satellite: { // 卫星图
          options: {
            v: 'st',
            style: 6
          }
        },
        Satellite_A: { // 卫星-标注图
          options: {
            v: 'st',
            style: 8
          }
        }
      }
    },
    /**
     * 腾讯地图
     */
    TencentMap: {
      url: 'http://rt{s}.map.gtimg.com/realtimerender?z={z}&x={x}&y={y}&type=vector&style={v}',
      options: {
        subdomains: '012'
      },
      v: {
        Normal: '0',
        Normal_R: '1',
        Terrain: 'demTiles', //地形图
        Satellite: 'sateTiles' //卫星图
      }
    }
  },
  EPSG4326: {
    /**
     * 全国天地图 4490
     */
    Tianditu_DataServer: {
      // url: 'http://t{s}.tianditu.com/DataServer?T={v}&x={x}&y={y}&l={z}',
      url: 'http://t{s}.tianditu.gov.cn/DataServer?T={v}&x={x}&y={y}&l={z}&tk=' + tiandtiu_tk,
      options: {
        zoomOffset: 1,
        subdomains: '01234567'
      },
      v: {
        Normal: 'vec_c', //矢量地图
        Normal_A: 'cva_c', //矢量-标注图
        Terrain: 'ter_c', //地形图
        Terrain_A: 'cta_c', //地形-标注图
        Satellite: 'img_c', //卫星-影像图
        Satellite_A: 'cia_c', //卫星-标注图
      }
    },
    Tianditu: {
      url: 'http://t{s}.tianditu.gov.cn/{v}_c/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER={v}&STYLE=default&TILEMATRIXSET=c&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=tiles&tk=' + tiandtiu_tk,
      options: {
        zoomOffset: 1,
        subdomains: '01234567'
      },
      v: {
        Normal: 'vec', //矢量地图
        Normal_A: 'cva', //矢量-标注图
        Terrain: 'ter', //地形图
        Terrain_A: 'cta', //地形-标注图
        Satellite: 'img', //卫星-影像图
        Satellite_A: 'cia', //卫星-标注图
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/provider/BasemapOptions.js